import BaseAction from "./BaseAction";
import SetupReducer from "../reducers/SetupReducer";

class SetupAction extends BaseAction {}

const action = new SetupAction(SetupReducer);

export default action;
